export enum ContractOwner {
  EMPLOYEE = 'EMPLOYEE',
  COMPANY = 'COMPANY',
}
